// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable max-lines */
import withIsomorphicRenderer from '@tcp/core/src/components/common/hoc/withIsomorphicRenderer';
import {
  getAPIConfig,
  getSessionStorage,
  isClient,
  scrollPage,
  setSessionStorage,
  getSiteId,
} from '@tcp/core/src/utils';
import dynamic from 'next/dynamic';
import { PropTypes } from 'prop-types';
import logger from '@tcp/core/src/utils/loggerInstance';
import React from 'react';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import { SHOP_THIS_STORE_EXIT_SEARCH_MODE } from '../../../../../constants/shopThisStore.constant';
import BuyItAgainDynamicStore from '../../../account/BuyItAgain/container/BuyItAgainDynamicStore';
import { getNavigationTree } from '../../ProductListing/container/ProductListing.selectors';
import SearchDetail from '../views/SearchDetail.view';
import NoResponseSearch from './components/NoResponseSearch';
import { mapDispatchToProps, mapStateToProps } from './reduxProps';
import { saveDefaultStore } from './SeacrhContainerHelper';
import { initActions } from './SearchDetail.actions';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import { getFeatureBrand, getQueryString, isFeatureBrandPage } from './SearchDetail.util';

const BackToTop = dynamic(() => import('@tcp/core/src/components/common/atoms/BackToTop'), {
  ssr: false,
});

const checkIfIsBackPage = ({ loadedProductCount, slpUrl }) => {
  const savedUrl = decodeURIComponent(slpUrl).replace(/\?/g, '');
  const newUrl =
    (isClient() &&
      decodeURIComponent(`${window.location.pathname}?${window.location.search}`).replace(
        /\?/g,
        ''
      )) ||
    '';

  return isClient() && savedUrl === newUrl && loadedProductCount > 0;
};

const shouldUnbxdRequestTrigger = (isBackSLPPage) => {
  return !isBackSLPPage;
};

const dynamicPromoModules = {
  Espot: dynamic(() =>
    // eslint-disable-next-line extra-rules/no-commented-out-code
    import(/* webpackChunkName: "espot" */ '@tcp/core/src/components/common/molecules/Espot')
  ),
  divisionTabs: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "divisionTabs" */ '@tcp/core/src/components/common/molecules/DivisionTabModule'
    )
  ),
  outfitCarousel: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "outfitCarousel" */ '@tcp/core/src/components/common/molecules/OutfitCarouselModule'
    )
  ),
  jeans: dynamic(() =>
    // eslint-disable-next-line extra-rules/no-commented-out-code
    import(/* webpackChunkName: "jeans" */ '@tcp/core/src/components/common/molecules/JeansModule')
  ),
  moduleX: dynamic(() =>
    // eslint-disable-next-line extra-rules/no-commented-out-code
    import(/* webpackChunkName: "moduleX" */ '@tcp/core/src/components/common/molecules/ModuleX')
  ),
  essentials: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "essentials" */ '@tcp/core/src/components/features/browse/ProductListing/organisms/EssentialShop'
    )
  ),
  moduleDynamic: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "moduleDynamic" */ '@tcp/core/src/components/common/molecules/ModuleDynamic'
    )
  ),
  moduleA: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "moduleA" */ '@tcp/core/src/components/common/molecules/ModuleA'
    )
  ),
  module_container: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "moduleContainer" */ '@tcp/core/src/components/common/molecules/ModuleContainer'
    )
  ),
  moduleD: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "moduleD" */ '@tcp/core/src/components/common/molecules/ModuleD'
    )
  ),
  moduleJ: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "moduleJ" */ '@tcp/core/src/components/common/molecules/ModuleJ'
    )
  ),
  moduleTabbedCarousel: dynamic(() =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "moduleTabbedCarousel" */ '@tcp/core/src/components/common/molecules/ModuleTabbedCarousel'
    )
  ),
};

class SearchDetailContainer extends React.PureComponent {
  static pageProps = {
    pageData: {
      pageName: 'search',
    },
  };

  static getInitialProps = async ({ props, query, isServer, ssrSearchPage, asPath }) => {
    const {
      getProducts,
      formValues,
      resetSlpScrollState,
      getL1CategoriesActn,
      defaultStore,
      setL1CategorySelection,
      setL1CategorySelectionCategoryContent,
      setL2CategorySelection,
      setL2CategorySelectionCategoryGroupId,
      isFeatureBrandEnabled,
      filters,
    } = props;
    let searchQuery;
    const isFeatureBrandView = isFeatureBrandPage(props.router, isFeatureBrandEnabled);
    if (!isServer) {
      ({
        router: {
          query: { searchQuery },
          // eslint-disable-next-line no-param-reassign
          asPath,
        },
      } = props);
      const queryString = getQueryString(
        isFeatureBrandView,
        props.router,
        asPath,
        isFeatureBrandEnabled,
        Object.keys(filters)
      );
      // eslint-disable-next-line prefer-destructuring
      searchQuery = getQueryString(
        isFeatureBrandView,
        props.router,
        asPath,
        isFeatureBrandEnabled,
        Object.keys(filters)
      )[0];
      const filterSortString = (queryString.length && queryString[1]) || '';
      const isBackSLPPage = checkIfIsBackPage(props);
      const queryParamPage = asPath?.split('page=')?.[1];
      let selectedPage = queryParamPage || 1;
      // eslint-disable-next-line radix
      selectedPage = selectedPage ? parseInt(selectedPage) : 1;
      if (shouldUnbxdRequestTrigger(isBackSLPPage)) {
        await getProducts({
          URI: 'search',
          asPath: filterSortString,
          searchQuery,
          ignoreCache: true,
          formValues,
          url: asPath,
          selectedPage,
        });
      } else if (isBackSLPPage) {
        resetSlpScrollState();
      }
    } else if (ssrSearchPage) {
      const queryString = getQueryString(
        isFeatureBrandView,
        props.router,
        asPath,
        isFeatureBrandEnabled,
        Object.keys(filters)
      );
      const filterSortString = (queryString.length && queryString[1]) || '';
      ({ searchQuery = '' } = query);
      await getProducts({
        URI: 'search',
        asPath: filterSortString,
        searchQuery,
        ignoreCache: true,
        url: asPath,
      });
    }
    setL1CategorySelection({});
    setL1CategorySelectionCategoryContent({});
    setL2CategorySelection({});
    setL2CategorySelectionCategoryGroupId('');
    if (defaultStore && defaultStore?.basicInfo && defaultStore?.basicInfo?.id) {
      getL1CategoriesActn(defaultStore?.basicInfo?.id);
    }
    return {
      isSlpSsr: isServer,
    };
  };

  constructor(props) {
    super(props);
    const { resetProducts, router, isFeatureBrandEnabled } = this.props;
    const isBackSLPPage = checkIfIsBackPage(props);
    if (!isBackSLPPage) {
      resetProducts();
    }
    this.state = {
      isFeatureBrandView: isFeatureBrandPage(router, isFeatureBrandEnabled),
      featureBrand: getFeatureBrand(router, isFeatureBrandEnabled),
    };
  }

  static contextType = LabelsContext;

  componentDidMount = async () => {
    const {
      resetSlpLoadingState,
      router: { asPath },
      getProducts,
      formValues,
      setBopisFilterStateActn,
      isUserLoggedIn,
      getBIABagPageProducts,
      isBIAABCustomVariableEnabled,
      isFeatureBrandEnabled,
      filters,
    } = this.props;
    const { isFeatureBrandView } = this.state;
    const searchQuery = getQueryString(
      isFeatureBrandView,
      this.props.router,
      asPath,
      isFeatureBrandEnabled,
      Object.keys(filters)
    )[0];
    const queryString = getQueryString(
      isFeatureBrandView,
      this.props.router,
      asPath,
      isFeatureBrandEnabled,
      Object.keys(filters)
    );
    const filterSortString = (queryString.length && queryString[1]) || '';
    resetSlpLoadingState({ isSLPPage: true });
    if (isBIAABCustomVariableEnabled && isUserLoggedIn) {
      await BuyItAgainDynamicStore();
      getBIABagPageProducts();
    }
    if (getSessionStorage('pdp_back') === 'false' && !filterSortString) {
      // this check is required to keep PDP back page anchoring working
      setBopisFilterStateActn(false);
      getProducts({
        URI: 'search',
        asPath: filterSortString,
        searchQuery,
        ignoreCache: true,
        formValues,
        url: asPath,
        selectedPage: 1,
      });
    }
    // This event will execute when user do browser back or forward on slp pagination page
    // ex: page1 -> page2 -> page3 then browser back to page2->back to->page1->forward to-> page2
    window.addEventListener('popstate', this.handleGetProducts);
    const scrollPointInStorage = getSessionStorage('SCROLL_POINT');
    const scrollPoint = isClient() ? scrollPointInStorage && parseInt(scrollPointInStorage, 10) : 0;
    if (
      isClient() &&
      scrollPoint &&
      getSessionStorage('pdp_back') === 'true' &&
      getSessionStorage('LAST_PAGE_PATH') === window.location.pathname
    ) {
      scrollPage(0, scrollPoint);
      setSessionStorage({ key: 'SCROLL_POINT', value: 0 });
      setSessionStorage({ key: 'pdp_back', value: false });
    }
  };

  handleShopThisStoreSearchExit = (asPath, searchQuery, previousSearchQuery) => {
    const { setBopisFilterStateActn, formValues, getProducts } = this.props;
    if (
      searchQuery === previousSearchQuery &&
      getSessionStorage(SHOP_THIS_STORE_EXIT_SEARCH_MODE) === 'true'
    ) {
      setBopisFilterStateActn(false);
      setSessionStorage({ key: SHOP_THIS_STORE_EXIT_SEARCH_MODE, value: false });
      const params = new URLSearchParams(asPath?.split('?')[1]);
      params.delete('bopisStoreId');
      params.delete('mode');
      const formData = formValues;
      if (formData) {
        delete formData.bopisStoreId;
        delete formData.mode;
      }
      getProducts({
        URI: 'search',
        asPath: params.toString(),
        searchQuery,
        ignoreCache: true,
        formValues: formData,
      });
    }
  };

  // eslint-disable-next-line complexity, sonarjs/cognitive-complexity
  componentDidUpdate(prevProps, prevState) {
    const {
      router: { asPath },
      getProducts,
      formValues,
      isLoggedIn: currentlyLoggedIn,
      onFavtLoad,
      resetFormValue,
      router,
      clearPromoDataOnRouteChange,
      setBopisFilterStateActn,
      isSearchResultsAvailable,
      isUserLoggedIn,
      isGuestFavEnabled,
      defaultWishListFromState,
      defaultWishlistId,
      isFeatureBrandEnabled,
      filters,
    } = this.props;
    const { isFeatureBrandView } = this.state;
    const { isFeatureBrandView: prevFeatureBrandView } = prevState;
    // Clears layout on route change to make sure promo data is not stale when jumping between different PLPs.
    if (prevProps.router.asPath !== '' && router.asPath !== prevProps.router.asPath) {
      clearPromoDataOnRouteChange();
      this.setState({
        isFeatureBrandView: isFeatureBrandPage(router, isFeatureBrandEnabled),
        featureBrand: getFeatureBrand(router, isFeatureBrandEnabled),
      });
    }

    if (isSearchResultsAvailable) {
      document.getElementById('web-app-content')?.classList.remove('mainPageHeight');
    }
    const {
      router: { asPath: previousAsPath },
      isLoggedIn,
    } = prevProps;
    const searchQuery = getQueryString(
      isFeatureBrandPage(router, isFeatureBrandEnabled),
      this.props.router,
      asPath,
      isFeatureBrandEnabled,
      Object.keys(filters)
    )[0];
    const queryString = getQueryString(
      isFeatureBrandPage(router, isFeatureBrandEnabled),
      this.props.router,
      asPath,
      isFeatureBrandEnabled,
      Object.keys(filters)
    );
    const filterSortString = (queryString.length && queryString[1]) || '';
    const previousSearchQuery = previousAsPath && previousAsPath.split('?')[0];
    const queryParamPage = asPath?.split('page=')?.[1]?.split('?')?.[0];
    const selectedPage = parseInt(queryParamPage || 1, 10);
    if (isFeatureBrandPage(router, isFeatureBrandEnabled) !== prevFeatureBrandView) {
      getProducts({
        URI: 'search',
        asPath: filterSortString,
        searchQuery,
        ignoreCache: true,
        formValues,
        url: asPath,
        selectedPage,
      });
    }
    // Added checks to run this only while landing on search page from Shop this Store page / Global Header and the search term is same and without any filters query params applied
    if (
      searchQuery === previousSearchQuery &&
      previousAsPath !== asPath &&
      !filterSortString &&
      isFeatureBrandPage(router, isFeatureBrandEnabled) === prevFeatureBrandView
    ) {
      resetFormValue();
      getProducts({
        URI: 'search',
        asPath: filterSortString,
        searchQuery,
        ignoreCache: true,
        formValues,
        url: asPath,
        selectedPage,
      });
    }
    if (!isFeatureBrandView && searchQuery !== previousSearchQuery) {
      setBopisFilterStateActn(false); // Reset Bopis filter for a new search term
      getProducts({
        URI: 'search',
        asPath: filterSortString,
        searchQuery,
        ignoreCache: true,
        formValues,
        url: asPath,
        selectedPage,
      });
      setSessionStorage({ key: 'pdp_back', value: false });
    }
    this.handleShopThisStoreSearchExit(asPath, searchQuery, previousSearchQuery);
    this.setDefaultStore();
    const defaultWishlistIdUpdated = defaultWishListFromState?.id || defaultWishlistId;
    if (
      (currentlyLoggedIn && isLoggedIn !== currentlyLoggedIn) ||
      this.shouldCallOnFavtLoad(
        isUserLoggedIn,
        isGuestFavEnabled,
        defaultWishlistIdUpdated,
        getSessionStorage(`defaultWishlistid${getSiteId()}`)
      )
    ) {
      onFavtLoad(true);
    }
  }

  shouldCallOnFavtLoad = (
    isUserLoggedIn,
    isGuestFavEnabled,
    defaultWishListID,
    wishListfromSession
  ) => !isUserLoggedIn && isGuestFavEnabled && !defaultWishListID && wishListfromSession !== null;

  /**
   * @param {state: {as: string}} routeProps
   * The value of as returned by onpopstate event when user does back or forward
   * ex: when user moves page1->page2->page3: Then browser back will return /us/search/tops?page=2
   * Basically we are calling products api when users do browser back or forward on alp pagination
   */
  handleGetProducts = (routeProps) => {
    try {
      const { getProducts, formValues, router, isFeatureBrandEnabled, filters } = this.props;
      const {
        state: { as: asPath },
      } = routeProps;
      const queryString = getQueryString(
        isFeatureBrandPage({ query: '', asPath }, isFeatureBrandEnabled),
        { ...router, asPath },
        asPath,
        isFeatureBrandEnabled,
        Object.keys(filters)
      );
      const filterSortString = (queryString.length && queryString[1]) || '';
      const searchQuery = getQueryString(
        isFeatureBrandPage({ query: '', asPath }, isFeatureBrandEnabled),
        { ...router, asPath },
        asPath,
        isFeatureBrandEnabled,
        Object.keys(filters)
      )[0];
      if (
        !searchQuery.includes('/search') &&
        !isFeatureBrandPage({ ...router, asPath }, isFeatureBrandEnabled)
      ) {
        return;
      }
      const queryParamPage = asPath?.split('page=')?.[1]?.split('?')?.[0];
      const selectedPage = parseInt(queryParamPage || 1, 10);
      getProducts({
        URI: 'search',
        asPath: filterSortString,
        searchQuery,
        ignoreCache: true,
        formValues,
        url: asPath,
        selectedPage,
      });
    } catch (err) {
      logger.info('Error at SearchDetail.container -> handleGetProducts', err);
    }
  };

  componentWillUnmount() {
    const { resetSlpLoadingState, updateFormValue } = this.props;
    updateFormValue('bopisStoreId', []);
    document.getElementById('web-app-content')?.classList.add('mainPageHeight');
    resetSlpLoadingState({ isSLPPage: false });
    // removing event on unMount of Search page
    window.removeEventListener('popstate', this.handleGetProducts);
    if (window.elem && !window.SEARCH_RESPONSE_INITIAL)
      window.elem.removeEventListener('unbxdResRecieved', this.searchResponseCallback);
  }

  setDefaultStore = () => {
    const { getFavoriteStoreById, formValues, favStore } = this.props;
    saveDefaultStore(getFavoriteStoreById, formValues, favStore, this.isFavStoreUpdated, () => {
      this.isFavStoreUpdated = true;
    });
  };

  checkSTSCondensedHeaderHeight = () => {
    if (isShopThisStoreModeOn()) {
      return {
        sTSCondensedHeaderHeight: 64,
        sTSCondensedHeaderPresent: true,
      };
    }
    return {
      sTSCondensedHeaderHeight: 0,
      sTSCondensedHeaderPresent: false,
    };
  };

  render() {
    const {
      formValues,
      productsBlock,
      products,
      currentNavIds,
      breadCrumbs,
      filters,
      totalProductsCount,
      filtersLength,
      initialValues,
      filterCount,
      longDescription,
      isLoadingMore,
      lastLoadedPageNumber,
      categoryId,
      getProducts,
      onSubmit,
      onPickUpOpenClick,
      searchedText,
      searchResultSuggestions,
      isSearchResultsAvailable,
      router: {
        query: { searchType },
        asPath: asPathVal,
      },
      currency,
      currencyAttributes,
      onAddItemToFavorites,
      isLoggedIn,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      pageNameProp,
      pageSectionProp,
      pageSubSectionProp,
      trackPageLoad,
      isSearchPage,
      isOnModelAbTestPlp,
      apiConfig,
      defaultWishListFromState,
      searchTopPromos,
      isPlcc,
      isBrierleyPromoEnabled,
      onSetLastDeletedItemIdAction,
      deleteFavItemInProgressFlag,
      isPlpPdpAnchoringEnabled,
      isDynamicBadgeEnabled,
      navigationData,
      isNonInvSessionFlag,
      alternateBrand,
      isShowBrandNameEnabled,
      isBopisFilterOn,
      slpUrl,
      trackWishListClick,
      isPaginationViewEnabled,
      productLimitPerPage,
      updateFormValue,
      defaultStore,
      trackClickAnalyticsBopisFilter,
      currentListingName,
      searchResultKeywordSuggestions,
      slpPersistSearchTerm,
      isDidYouMeanEnabled,
      isSlpPersistEnabled,
      initialSearchTerm,
      oldSearchResultSuggestions,
      didYouMeanNullSearch,
      isSearchEnhancementRedesignEnabled,
      isPLPImageHeightBasedOnAspectRatio,
      trackAnalyticsClick,
      getPaginatedProducts,
      isSyteEnabled,
      sortByRatingLabel,
      isHideOriginalPriceAndMarchantTagEnabled,
      isMostFavoritedBadgeEnabled,
      setPLPSLPAddToCartCTA,
      isInfluencerBadgeEnabled,
      isTileRedesignAB,
      isInfluencerPicksEnabled,
      toastModalState,
      showToastModalAction,
      User,
      session,
      isGlobalHeaderRedesignEnabled,
      isHeaderScrollViewDisabled,
      ...otherProps
    } = this.props;
    const { isFeatureBrandView, featureBrand } = this.state;
    const apiConfigObj = getAPIConfig();
    const { extraConfig } = this.context;
    const { isHeaderStickyClassPresent, stickyHeaderHeight, headerMiddleNavHeight } =
      extraConfig || {};
    const { isNonInvStagEnabled } = apiConfigObj || {};
    const isSecureImageFlagEnabled = isNonInvSessionFlag && isNonInvStagEnabled;
    const isDidYouMeanAbEnabled = isDidYouMeanEnabled === undefined || isDidYouMeanEnabled;
    const navTree = getNavigationTree(navigationData);
    const isPromoProductsSearch = slpUrl && slpUrl.includes('/promotional-products/');
    const isSTSSearch = slpUrl && slpUrl.includes('/shop-this-store');
    return (
      <React.Fragment>
        <BackToTop />
        {isSearchResultsAvailable && products && products.length === 0 ? (
          <NoResponseSearch {...this.props} isFeatureBrandView={isFeatureBrandView} />
        ) : (
          <SearchDetail
            filters={filters}
            formValues={formValues}
            filtersLength={filtersLength}
            getProducts={getProducts}
            isLoadingMore={isLoadingMore}
            initialValues={initialValues}
            filterCount={filterCount}
            onSubmit={onSubmit}
            products={products}
            productsBlock={productsBlock}
            totalProductsCount={totalProductsCount}
            searchedText={searchedText}
            searchResultSuggestions={searchResultSuggestions}
            currencyAttributes={currencyAttributes}
            currency={currency}
            onAddItemToFavorites={onAddItemToFavorites}
            isLoggedIn={isLoggedIn}
            isSearchListing
            asPathVal={asPathVal}
            AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
            removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
            trackPageLoad={trackPageLoad}
            isSearchPage={isSearchPage}
            searchType={searchType}
            isOnModelAbTestPlp={isOnModelAbTestPlp}
            wishList={defaultWishListFromState}
            isSearchResultsAvailable={isSearchResultsAvailable}
            searchTopPromos={searchTopPromos}
            isPlcc={isPlcc}
            isBrierleyPromoEnabled={isBrierleyPromoEnabled}
            onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
            deleteFavItemInProgressFlag={deleteFavItemInProgressFlag}
            isPlpPdpAnchoringEnabled={isPlpPdpAnchoringEnabled}
            isDynamicBadgeEnabled={isDynamicBadgeEnabled}
            breadCrumbs={breadCrumbs}
            dynamicPromoModules={dynamicPromoModules}
            isSecureImageFlagEnabled={isSecureImageFlagEnabled}
            alternateBrand={alternateBrand}
            isShowBrandNameEnabled={isShowBrandNameEnabled}
            isBopisFilterOn={isBopisFilterOn}
            defaultStore={defaultStore}
            isPromoProductsSearch={isPromoProductsSearch}
            isSTSSearch={isSTSSearch}
            trackWishListClick={trackWishListClick}
            navTree={navTree}
            currentNavIds={currentNavIds}
            isPaginationViewEnabled={isPaginationViewEnabled}
            productLimitPerPage={productLimitPerPage}
            updateFormValue={updateFormValue}
            newFilterTrackAnalytics={trackClickAnalyticsBopisFilter}
            trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
            currentListingName={currentListingName}
            searchResultKeywordSuggestions={searchResultKeywordSuggestions}
            slpPersistSearchTerm={slpPersistSearchTerm}
            isSlpPersistEnabled={isSlpPersistEnabled}
            isDidYouMeanEnabled={isDidYouMeanAbEnabled}
            didYouMeanNullSearch={didYouMeanNullSearch}
            isSearchEnhancementRedesignEnabled={isSearchEnhancementRedesignEnabled}
            isPLPImageHeightBasedOnAspectRatio={isPLPImageHeightBasedOnAspectRatio}
            isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
            trackAnalyticsClick={trackAnalyticsClick}
            isSyteEnabled={isSyteEnabled}
            getPaginatedProducts={getPaginatedProducts}
            sortByRatingLabel={sortByRatingLabel}
            isMostFavoritedBadgeEnabled={isMostFavoritedBadgeEnabled}
            setPLPSLPAddToCartCTA={setPLPSLPAddToCartCTA}
            isInfluencerBadgeEnabled={isInfluencerBadgeEnabled}
            isTileRedesignAB={isTileRedesignAB}
            isInfluencerPicksEnabled={isInfluencerPicksEnabled}
            showToastModalAction={showToastModalAction}
            toastModalState={toastModalState}
            User={User}
            APIConfig={apiConfig}
            session={session}
            isHeaderStickyClassPresent={isHeaderStickyClassPresent}
            stickyHeaderHeight={stickyHeaderHeight}
            checkSTSCondensedHeaderHeight={this.checkSTSCondensedHeaderHeight()}
            isGlobalHeaderRedesignEnabled={isGlobalHeaderRedesignEnabled}
            headerMiddleNavHeight={headerMiddleNavHeight}
            isHeaderScrollViewDisabled={isHeaderScrollViewDisabled}
            isFeatureBrandView={isFeatureBrandView}
            featureBrand={featureBrand}
            {...otherProps}
          />
        )}
      </React.Fragment>
    );
  }
}

SearchDetailContainer.pageInfo = {
  pageId: 'search',
  pageData: {
    pageName: 'search',
    pageSection: 'search',
    pageSubSection: 'search',
    loadAnalyticsOnload: false,
  },
};

SearchDetailContainer.getInitActions = () => initActions;

SearchDetailContainer.propTypes = {
  router: PropTypes.shape({
    query: PropTypes.shape({
      searchQuery: PropTypes.string,
    }),
  }).isRequired,
  getProducts: PropTypes.func.isRequired,
  getMoreProducts: PropTypes.func.isRequired,
  getSlpPaginatedProducts: PropTypes.func.isRequired,
  // navTree: PropTypes.shape({}),
  filters: PropTypes.shape({}),
  isBopisFilterEnabled: PropTypes.bool,
  filtersLength: PropTypes.shape({}),
  initialValues: PropTypes.shape({}),
  formValues: PropTypes.shape({
    sort: PropTypes.string.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoadingMore: PropTypes.bool,
  selectedPage: PropTypes.bool,
  isSearchResultsAvailable: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  productsBlock: PropTypes.arrayOf(PropTypes.shape({})),
  products: PropTypes.arrayOf({}),
  currentNavIds: PropTypes.arrayOf(PropTypes.string),
  breadCrumbs: PropTypes.shape({}),
  isInternationalShipping: PropTypes.bool.isRequired,
  searchTopPromos: PropTypes.arrayOf(
    PropTypes.shape({
      // Only including the most important property
      moduleName: PropTypes.string,
    })
  ),
  isPlcc: PropTypes.bool,
  isBrierleyPromoEnabled: PropTypes.bool,
  onSetLastDeletedItemIdAction: PropTypes.func,
  deleteFavItemInProgressFlag: PropTypes.bool,
  resetSlpScrollState: PropTypes.func.isRequired,
  isPlpPdpAnchoringEnabled: PropTypes.bool,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  isABTestForStickyFilter: PropTypes.bool,
  isPromoApplied: PropTypes.bool,
  clearPromoDataOnRouteChange: PropTypes.func.isRequired,
  isShowBrandNameEnabled: PropTypes.bool,
  trackWishListClick: PropTypes.func,
  defaultStore: PropTypes.shape({}).isRequired,
  isSlpPersistEnabled: PropTypes.bool,
  isSlpSsr: PropTypes.bool,
  isSearchEnhancementRedesignEnabled: PropTypes.bool,
  isPLPImageHeightBasedOnAspectRatio: PropTypes.bool,
  isTopRatedBadgeEnabledSLP: PropTypes.bool,
  isBestSellerBadgeEnabledSLP: PropTypes.bool,
  isOneClickATCEnabled: PropTypes.bool,
  addToBagEcom: PropTypes.func,
  isMostFavoritedBadgeEnabled: PropTypes.bool,
  setPLPSLPAddToCartCTA: PropTypes.string,
  isTileRedesignAB: PropTypes.bool,
  isInfluencerPicksEnabled: PropTypes.bool,
  toastModalState: PropTypes.shape({
    duration: PropTypes.number,
    showToast: PropTypes.bool,
  }),
  showToastModalAction: PropTypes.func,
  promotionsData: PropTypes.shape({}),
  isSLPNewTileImplementationEnabled: PropTypes.bool,
};

SearchDetailContainer.defaultProps = {
  // navTree: {},
  filters: {},
  filtersLength: {},
  initialValues: {},
  isLoadingMore: false,
  selectedPage: 1,
  isSearchResultsAvailable: false,
  productsBlock: [],
  isLoggedIn: false,
  products: [],
  currentNavIds: [],
  breadCrumbs: [],
  searchTopPromos: [],
  isPlcc: false,
  isBrierleyPromoEnabled: false,
  onSetLastDeletedItemIdAction: () => {},
  deleteFavItemInProgressFlag: false,
  isPlpPdpAnchoringEnabled: false,
  isDynamicBadgeEnabled: false,
  isABTestForStickyFilter: false,
  isPromoApplied: false,
  isShowBrandNameEnabled: false,
  isBopisFilterEnabled: false,
  trackWishListClick: () => {},
  isSlpPersistEnabled: false,
  isSlpSsr: false,
  isSearchEnhancementRedesignEnabled: false,
  isPLPImageHeightBasedOnAspectRatio: false,
  isTopRatedBadgeEnabledSLP: false,
  isBestSellerBadgeEnabledSLP: false,
  isOneClickATCEnabled: false,
  addToBagEcom: () => {},
  isMostFavoritedBadgeEnabled: false,
  setPLPSLPAddToCartCTA: null,
  isTileRedesignAB: false,
  isInfluencerPicksEnabled: false,
  toastModalState: {
    duration: 0,
    showToast: false,
  },
  showToastModalAction: () => {},
  promotionsData: {},
  isSLPNewTileImplementationEnabled: false,
};

export default withIsomorphicRenderer({
  WrappedComponent: SearchDetailContainer,
  mapStateToProps,
  mapDispatchToProps,
});
